import * as React from 'react';

import { Dropdown } from 'semantic-ui-react';

import { ErrorMsg } from '../';
import { localeData } from '../../../locales/data';
import { convertArrayFromDropdown } from '../../../shared/helpers';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

interface GenderSelectProps {
  placeholder: string;
  handleChange: (event: any, options: any) => void;
  errors?: any[];
  value: any;
  options: any;
  tabindex?: number;
}

class GenderSelect extends React.Component<GenderSelectProps> {
  handleChange = (event: any) => {
    this.props.handleChange(event, { fieldPos: 7, name: 'gender' });
  };

  componentDidMount() {
    this.props.handleChange({ value: this.props.value, label: 'gender' }, { fieldPos: 7, name: 'gender' });
  }

  render() {
    const { errors = [], options = [], value, placeholder, tabindex = 0 } = this.props;

    return (
      <div className="form-content">
        <label htmlFor="gender" className="input__label">
          <FormattedMessageHelper tagName="span" id="step1.gender" defaultMessage={localeData.en['step1.gender']} />
          <sup>*</sup>
        </label>
        <Dropdown
          className="dropdown-custom"
          placeholder={placeholder}
          options={options && convertArrayFromDropdown(options)}
          selection={true}
          value={value}
          onChange={this.props.handleChange}
          name="gender"
          searchInput={{ id: 'gender' }}
          tabIndex={tabindex}
        />
        <div className="form-radio__error">{errors.length !== 0 && <ErrorMsg errors={errors} />}</div>
        <div className="select__info_small">
          <FormattedMessageHelper tagName="span" id="account.gender.message" defaultMessage={localeData.en['account.gender.message']} />
        </div>
      </div>
    );
  }
}

export default GenderSelect;
